export class AuthRequest {

  auth: {
    tokenRecaptcha: string;
  };

  constructor(
    tokenRecaptcha: string
  ) {
    this.auth = {
      tokenRecaptcha: tokenRecaptcha
    };
  }
}
